import MuteButton from "./MuteButton";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(MuteButton);
